import React from 'react';
import { Container } from '@michelin/acid-components';
import GLOBAL_CONFIG from 'global-variables';

export function LiveTrackModule() {
  return (
    <>
      <Container height="100%" spacing={0}>
        <iframe title="LiveTrack" src={GLOBAL_CONFIG.liveTrackUrl} style={{ border: 'none', flex: 1 }} />
      </Container>
    </>
  );
}
